module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_04-4f7e9e9a0de95aeb9b73fb1e5bed2e91.png";